import Layout from '../../layout/index'

const homeCareRouter = {
  path: '/homecare',
  component: Layout,
  redirect: '/homecare/index',
  children: [
    {
      path: 'index',
      name: 'homeCare',
      component: () => import('../../views/homecare/index')
    },
    {
      path: 'detail',
      name: 'homeCareDetail',
      component: () => import('../../views/homecare/detail')
    }
  ]
}
export default homeCareRouter
